// extracted by mini-css-extract-plugin
export default {"root":"styles_root__H47tR","button":"styles_button__4cAlL"};